import { useEffect, useState } from "react";

interface UseTypingAnimationResult {
  displayedText: string;
  isComplete: boolean;
}

export const useTypingAnimation = (
  text: string,
  speed: number = 50
): UseTypingAnimationResult => {
  const [displayedText, setDisplayedText] = useState("");
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    let index = 0;
    const timer = setInterval(() => {
      if (index < text.length) {
        setDisplayedText(text.slice(0, index + 1));
        index++;
      } else {
        setIsComplete(true);
        clearInterval(timer);
      }
    }, speed);

    return () => clearInterval(timer);
  }, [text, speed]);

  return { displayedText, isComplete };
};

export default useTypingAnimation;
